<template>
  <h1 class="brand">
    <span class="prepend">Follow</span><span class="append">Up</span>
  </h1>
</template>

<script>
export default {};
</script>

<style scoped>
.brand {
  font-weight: bold;
  font-size: 45px;
  letter-spacing: -3px;
  color: black;
  margin: 30px 0;
  padding-bottom: 5px;
  cursor: default;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h1.brand {
  font-size: 36px;
  margin: 0;
  padding-bottom: 0;
  overflow: hidden;
  line-height: 36px;
  float: left;
  cursor: pointer;
}

.brand span.append {
  font-style: italic;
  background-color: #ffd732;
  color: black;
  padding-right: 20px;
  -moz-border-radius: 0 30px 30px 0;
  -webkit-border-radius: 0 30px 30px 0;
  border-radius: 0 30px 30px 0;
}

.brand span.prepend {
  background-color: #c1c1c1;
  display: inline-block;
  border-radius: 30px 0 0 30px;
  padding: 3px 0 2px 16px;
  padding-right: 10px;
}

h1.brand span.prepend {
  background-color: #c1c1c1;
}
</style>
